import { FileSensitivity } from 'common/enum/file-sensitivity.enum';

export const sensitivityLabelToIndex = {
  [FileSensitivity.PUBLIC]: 4,
  [FileSensitivity.CONFIDENTIAL]: 2,
  [FileSensitivity.HIGHLY_CONFIDENTIAL]: 1,
  [FileSensitivity.PRIVATE_CONFIDENTIAL]: 3,
};
